module.exports = __webpack_public_path__ + "img/wp.3fcec061.svg";